export default "__VITE_ASSET__DuUKcq1J__"